var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoeLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 445,
    viewBox: "0 0 575 445",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.998%",
    x2: "99.991%",
    y2: "49.998%",
    id: "hudx9ulpha"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.008%",
    x2: "100%",
    y2: "50.008%",
    id: "0clxtv9t6b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2757E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B8EB",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A398EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.007%",
    x2: "100%",
    y2: "50.007%",
    id: "3li068616c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.688%",
    y1: "73.62%",
    x2: "-7.431%",
    y2: "-26.616%",
    id: "w2k51vq8ed"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.092 69.499c47.82-29.755 29.521-64.982-51.032-48.121-129.12 27.05-230.094 90.526-218.035 114.086 17.624 22.073 68.862-17.203 88.529.27C165.22 153.21-28.798 200.6 3.674 250.345c25.367 38.853 111.908-36.066 130.387-5.41 18.48 30.657-75.84 73.431-108.42 127.134-32.579 53.702 22.814 108.694 183.3 37.175 108.58-48.392 88.591-26.058 68.134.081-13.84 17.673 28.99 61.935 96.99 10.82 70.24-52.837 136.998-119.623 82.487-102.185-83.898 26.843-54.7-26.5-19.667-63.043 35.034-36.545 106.11-83.26 33.973-114.51-30.735-13.327-112.763 35.398-113.374 11.324-.612-24.074 161.474-94.998 111.684-107.036-49.79-12.037-182.31 49.258-143.076 24.805z",
    fill: "url(#hudx9ulpha)",
    fillRule: "nonzero",
    transform: "translate(0 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m88.953 120.82-3.07 108.383L69 255.915l9.21 31.011 40.533 10.728 130.185 3.07 61.065 6.453 151.714-6.66 42.342-36.02-.61-25.49-16.72-14.854-110.016-35.905-5.867-9.968-14.854-.297-8.17-5.537s-13.153-7.04-14.333-7.287c-1.18-.248-12.478-3.573-12.478-3.573l-11.717-8.194-11.834-5.579s-10.447-6.601-10.596-7.064c-.148-.462-14.127-7.212-14.127-7.212l-25.334-17.808s-10.587.454-12.122-1.08C233.736 113.112 209.013 95 209.013 95l-12.436 2.608-9.845 9.547-2.475 21.183 5.528 7.988-11.668 4.3-52.203-1.23-36.96-18.575z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0clxtv9t6b)",
    fillRule: "nonzero",
    d: "M87.521 119.935 50.61 155.527l116.725 4.01 70.242 13.913-24.575-39.527z",
    transform: "translate(69 95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m220.21 126.284-12.13-11.669c-10.208-10.208 4.382-19.4 4.382-19.4M216.423 128.8l-33.635 15.308M229.131 135.699l-30.037 17.495M241.831 142.598 215.4 162.287M254.531 149.497l-22.817 21.876M267.231 156.404l-19.211 24.054M279.931 163.302l-15.596 26.242M292.631 170.201l-11.99 28.437M305.331 177.1l-8.384 30.623M318.039 183.998l-4.778 32.811M330.739 190.897l-1.172 34.997M343.439 197.796l2.442 37.192M356.139 204.695l6.049 39.379M368.839 211.593l9.655 41.566M381.539 218.492l13.269 43.753",
    stroke: "#D1D3D4",
    strokeWidth: 2.047,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#3li068616c)",
    fillRule: "nonzero",
    d: "M111.989 47.755 56.84 95.617l161.765 13.657-105.494-62.609",
    transform: "translate(69 95)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w2k51vq8ed)",
    d: "m342.6 104.512 75.16 24.65-41.945 36.152-50.007 1.93z",
    transform: "translate(69 95)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    stroke: "#27AAE1",
    strokeLinejoin: "round",
    strokeWidth: 2.047
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m411.601 199.512 75.16 24.649M408.803 209.968l70.96 20.217M406.006 220.423l66.767 15.786M403.208 230.878l62.576 11.355M400.403 241.334l58.391 6.932M397.605 251.789l54.2 2.501M394.808 262.245l50.007-1.931"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D3D4",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "M87.336 224.095 70.37 252.507l5.983 35.245M100.152 234.37l-11.8 20.646 6.733 38.306M113.355 245.27l-7.023 12.246 6.363 39.52M129.471 250.799l-5.157 9.226 5.62 37.943M147.28 251.715l-4.985 10.818 4.877 36.375M165.55 252.482l-5.274 12.56 4.143 34.799M184.125 253.101l-5.868 14.45 3.4 33.222M202.395 254.636l-6.156 15.423 2.475 29.097M221.58 251.203l-7.36 21.365 1.84 25.82M238.365 254.595l-6.164 20.482.9 23.006M255.142 257.978l-4.96 19.607.421 21.728M271.926 261.37l-3.762 18.724.173 22.9M288.703 264.753l-2.558 17.85-1.04 23.782M305.488 268.145l-3.144 39.181M88.252 145.94l46.674 36.763M89.861 132.349l53.795 42.325M100.3 125.673l52.095 40.971M138.994 141.022l22.132 17.593M156.802 140.716l13.063 9.87M140.875 191.879l29.931 24.41M157.462 193.249l25.705 24.443M174.057 194.619l21.464 24.476M190.652 195.997l17.222 24.5M207.239 197.367l12.988 24.541M223.833 198.737l8.748 24.574M240.42 200.107l4.522 24.607M257.015 201.485l.281 24.632M273.61 202.854l-3.961 24.666M290.197 204.224l-8.195 24.699"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m216.423 128.8 23.329-12.361 8.78-.537 27.091 19.682 17.239 7.658 3.953 6.197 12.46 3.911 14.788 8.376 23.832 8.244 8.079 7.971 13.706 2.352 3.68 5.991 8.179 32.208zM88.45 161.635l68.071 53.3-71.058 11.644z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m156.521 214.935-36.911 35.592-31.605-24.757z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m156.521 214.935 125.481 13.988 24.575 39.527-65.406-12.345-121.561-5.578zM182.111 141.665l-56.27 48.952-37.39-28.982-1.577-40.633 40.212 18.939zM182.788 144.108l212.02 118.137-13.27-43.753L216.424 128.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m180.989 142.755-55.149 47.862 164.357 13.607zM290.197 204.224l-8.195 24.699-125.48-13.988-30.682-24.318zM290.197 204.224l43.488 62.617-27.108 1.61-24.575-39.528zM290.197 204.224l104.611 58.02-61.123 4.597zM373.36 186.284l21.448 75.96 16.793-62.732zM394.808 262.245l50.007-1.931 41.946-36.153-75.16-24.649z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m305.488 268.145-3.144 39.18 14.061-.511 2.41-38.884zM331.069 267.072l-1.873 39.255 14.07-.512.775-39.733zM360.81 265.042l-1.709 41.285 14.062-.512.61-41.755zM389.32 262.698l-1.312 40.906 14.07-.512.116-40.938zM419.96 261.758l.908 40.162 14.804-.594-2.69-40.08zM445.12 259.983l7.403 42.045 15.695-8.145-11.99-43.373zM466.931 241.284l16.24 42.383 17.758-13.765-24.863-36.317z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    fill: "#72F596",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m279.832 135.93-31.44 30.92 14.474 8.74 30.425-31.556zM306.404 151.543l-31.449 30.912 15.704 9.201 30.425-31.547zM333.47 165.118l-31.564 32.208 15.696 9.2 30.549-32.843zM361.362 177.875l-30.631 34.28 15.695 9.2 30.318-36.985z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    strokeWidth: 4.679,
    strokeLinejoin: "round",
    d: "m86.725 118.593 1.189 45.7-.578 59.802-16.966 28.412 5.983 35.245 43.1 12.37 120.109-2.385 60.834 9.952 161.353-7.147 44.412-33.99-.75-26.29-18.65-16.1-110.058-35.955-1.75-6.057-14.482-5.48-4.497 1.271-5.579-3.119-2.5-4.852-15.002-6.37-5.67 1.485-6.23-3.54-1.188-4.3-15.167-6.766-4.118 1.386-7.377-5.24-.281-3.383-13.385-7.815-3.854.157-27.091-19.682-11.008-.841-25.062-19.846-13.624 1.204-14.788 9.317-.949 19.36 9.54 10.85-10.53 5.72-55.025-1.725z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 2.047,
    strokeLinejoin: "round",
    d: "m486.76 224.161-41.945 36.153-138.238 8.136-65.406-12.345-121.561-5.578-32.274-26.432-16.966 28.412 5.24 33.182 43.843 14.433 120.109-2.385 60.834 9.952 161.353-7.147 44.412-33.99-.75-26.29z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m261.446 244.032-.099-14.078-8.796-7.427 4.95-4.29-.09-12.66-11.264-9.423-10.191.074-.075-9.902-11.412.082.074 9.903h-6.494l-.075-9.903-11.412.083.074 9.902-16.306.116.42 58.309 16.299-.116.099 14.029 11.412-.083-.099-14.028h6.495l.099 14.028 11.412-.082-.099-14.029 13.022-.09 12.056-10.415zm-20.968-32.092v4.126l-3.152 2.6-29.906.214-.066-9.333 29.906-.206 3.218 2.599zm-.289 29.41-32.57.231-.075-10.414 32.57-.23 4.275 3.465v3.416l-4.2 3.532z",
    stroke: "#231F20",
    strokeWidth: 2.047,
    fill: "#72F596",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(199 1)",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.131
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 143.584,
    r: 3.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.797 143.543 160.163 0H375"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(226 111)",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.131
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 106.062,
    r: 3.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.131 105.796 116.502 0H348"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316 218)",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.131
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 3.062,
    r: 3.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.815 2.809H258"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(261 270)",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.131
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.335 3.45 127.173 171H313"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 3.062,
    r: 3.062
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(373 255)",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.131
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.626 62.672 75.5H195"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.062,
    cy: 3.062,
    r: 3.062
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoeLines);
export default __webpack_public_path__ + "static/media/shoeLines.6d57dac3d9a6868274714574910e3385.svg";
export { ForwardRef as ReactComponent };